import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIsMobile } from 'utils/hooks';
import { Dialog } from 'components/Ui';
import ContentfulClient from 'utils/ContentfulClient';
import { fetchImage } from 'utils/contentfulUtils';
import LoadingIndicator from 'components/LoadingIndicator';
import { isCanadianBrand } from 'utils/translation';

import styles from './styles.scss';

const HowToReadYourBillDialog = ({ open, onClose, isAcquisition }) => {
  const isMobile = useIsMobile();
  const [url, setUrl] = useState(null);

  useEffect(() => {
    (async () => {
      if (open) {
        const contentfulClient = new ContentfulClient();
        const title = isAcquisition
          ? isCanadianBrand()
            ? 'HowToReadYourInvoiceCA'
            : 'HowToReadYourBillAcquisition'
          : 'HowToReadYourBill';
        const image = await fetchImage(contentfulClient, title);
        setUrl(image.items[0].fields.file.url);
      }
    })();
  }, [open]);

  return (
    <Dialog
      className={styles.dialog}
      isAutoClose={false}
      isCloseIcon
      open={open}
      onClose={onClose}
      fullScreen={isMobile}
    >
      <div className={styles.content}>
        {!url && <LoadingIndicator className={styles.loadingIndicator} />}
        {url && (
          <img
            className={styles.image}
            src={`${url}?fm=webp`}
            alt="How To Read Your Bill with an example of your first invoice and a regular invoice"
          />
        )}
      </div>
    </Dialog>
  );
};

HowToReadYourBillDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  isAcquisition: PropTypes.bool,
};

export default HowToReadYourBillDialog;
